import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.css']
})
export class PhotoGalleryComponent implements OnInit {

  arr = [{
    deleteImage: false
  }]

  objArr: any = [];
  baseUrl = environment.basePath;
  photoLimit=6;

  constructor(private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.getPhotoGallery()
  }

  renderImage(image: any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
    }
    // let image = this.authService.spilturl(e)
    // return image;
  }

  onImgError(event: Event) {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;
    // prevent infinite loop if placeholder also fails
    if (img.getAttribute('data-fallback-applied') === '1') return;
    img.setAttribute('data-fallback-applied', '1');
    img.src = 'assets/placeholderCoverPhoto.jpeg';
  }

  getPhotoGallery() {
    this.authService.onphotoGallery().subscribe((res: any) => {
      this.objArr = res.data.images
      this.photoLimit = res.data.photoLimit
      console.log(res, 'data')
    },
      error => {
        console.log(error)
      })
  }


  deleteImages(i) {
    if(this.objArr.length == 0) return

     this.objArr.splice(i,1)
      this.authService.updatePhotoGallery({ imagePath: this.objArr }).subscribe((res: any) => {
        console.log(res)
        this.authService.successMessage('Image has been deleted.','success')

      },
        error => {
          console.log(error)
        }
      )

  }


}
